import { httpClient } from "@/shared/services/http";
import { FeedbackQuestionsResponse, SubmitFeedbackRequest } from "./candidate-feedback.types";

export class CandidateFeedbackHttpService {
  static async getQuestions(inviteId: number): Promise<FeedbackQuestionsResponse> {
    const { data } = await httpClient.get<FeedbackQuestionsResponse>(
      `/api/assessments/invites/${inviteId}/feedback/questions`,
    );
    return data;
  }

  static async submitFeedback(inviteId: number, request: SubmitFeedbackRequest): Promise<void> {
    await httpClient.post(`/api/assessments/invites/${inviteId}/feedback`, request);
  }
}
